
import React from 'react';
import { Detector } from 'react-detect-offline';

const OnlineStateContext = React.createContext('online');

const withOnlineDetector = (Component) =>
  (props) => (
    <Detector
      polling={{ url: '/api/ping' }}
      render={({ online }) => (
        <Component {...props} value={ online } />
      )}
    />
  );

export const OnlineProvider = withOnlineDetector(OnlineStateContext.Provider);

export const withOnlineStatus = (Component) => 
  (props) => (
    <OnlineStateContext.Consumer>
      {context => <Component {...props} online={context} />}
    </OnlineStateContext.Consumer>
  );

export const Online = withOnlineStatus(
  ({ online, children }) => online && children
);
export const Offline = withOnlineStatus(
  ({ online, children }) => !online && children
);